<script>
    import * as Utils from '@js/modules/utils';
    import I18n from '@js/modules/translations';
    import Computation from '@js/modules/computation';

    import UserFilterItem from '@js/components/user/filter/UserFilterItem.svelte';
    import {searchStore} from '@js/stores/searchStore';

    const {
        allFilters,
        onFilterChange
    } = $props();

    const initialFilters = {
        rideTypes: new Set(allFilters.rideTypes),
        levels: new Set(allFilters.levels),
        distance: new Set(),
        duration: new Set()
    };

    const _updateFilters = Utils.debounce((selectedFilters) => {
        onFilterChange(selectedFilters);
    }, 400);

    const _handleFilterChange = (filterType, filterName, filterData, checked) => {
        const selectedFilters = {...searchStore.selectedFilters};

        if (filterType === 'range') {
            if ((1 - allFilters[filterName].min / filterData[0]) < 0.08 && (1 - filterData[1] / allFilters[filterName].max) < 0.08) {
                selectedFilters[filterName] = undefined;
            } else {
                selectedFilters[filterName] = new Set(filterData);
            }
        } else if (filterType === 'switch') {
            if (filterData) {
                selectedFilters[filterName] = filterData;
            } else {
                selectedFilters[filterName] = undefined;
            }
        } else if (filterType === 'select') {
            if (!selectedFilters[filterName]) {
                selectedFilters[filterName] = new Set(initialFilters[filterName]);
            }

            if (checked) {
                selectedFilters[filterName].add(filterData.id);
            } else {
                selectedFilters[filterName].delete(filterData.id);
            }
        }

        _updateFilters(selectedFilters);
    };
</script>

<div class="mt-2 mx-4">
    <div class="flex items-center flex-wrap justify-start gap-3">
        <UserFilterItem type="select"
                        name={I18n.t('js.user.common.filters.ride_type')}
                        elementId="rideTypes"
                        elements={allFilters.rideTypes.map((rideType) => ({
                                                  id: rideType,
                                                  name: I18n.t('js.ride.enums.ride_type')[rideType]
                                              }))}
                        selectedElements={$searchStore.selectedFilters.rideTypes || initialFilters.rideTypes}
                        onFilterChange={_handleFilterChange}/>

        <UserFilterItem type="range"
                        name={I18n.t('js.user.common.filters.distance')}
                        elementId="distance"
                        elements={[allFilters.distance.min, allFilters.distance.max]}
                        elementFormatter={(element) => Computation.formatDistance(element, {
                            smartUnit: true,
                            kUnit: false,
                            decimalLimit: 1
                        })}
                        selectedElements={$searchStore.selectedFilters.distance || initialFilters.distance}
                        onFilterChange={_handleFilterChange}/>

        <UserFilterItem type="range"
                        name={I18n.t('js.user.common.filters.duration')}
                        elementId="duration"
                        elements={[allFilters.duration.min, allFilters.duration.max]}
                        elementFormatter={(element) => Computation.formatDuration(element, {withSeconds: false})}
                        selectedElements={$searchStore.selectedFilters.duration || initialFilters.duration}
                        onFilterChange={_handleFilterChange}/>

        <UserFilterItem type="select"
                        name={I18n.t('js.user.common.filters.level')}
                        elementId="levels"
                        elements={allFilters.levels.map((level) => ({
                                                  id: level,
                                                  name: I18n.t('js.ride.enums.level')[level]
                                              }))}
                        selectedElements={$searchStore.selectedFilters.levels || initialFilters.levels}
                        onFilterChange={_handleFilterChange}/>
    </div>
</div>
